module.exports = __webpack_public_path__ + "static/img/50.96664d71.gif";